import { Key, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DownOutlined, LoadingOutlined, UpOutlined } from "@ant-design/icons";
import { AppDispatch } from "store";
import { fetchMenu } from "store/articleCategory/articleCategory.slice";
import LinkLanguage from "locales/LinkLanguage";
import { PhotoDisplayHandler } from "components";
import "./MobileMenu.scss";
import MobileMenuItem from "./MobileMenuItem";
import { useNavigate } from "react-router-dom";

const MobileMenu = ({ action }: any) => {
  const { is_fetch, article_category } = useSelector(
    (store: { articleCategory: any }) => store.articleCategory
  );
  const dispatch: (arg: any) => AppDispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchMenu(null));
  }, [dispatch]);

  const [openItem, setOpenItem] = useState(false);
  const [openSubItem, setOpenSubItem] = useState(false);
  const [itemClicked, setItemClicked] = useState<string | null>(null);
  const [subItemClicked, setSubItemClicked] = useState<string | null>(null);

  const handleOpenItem = (slug: string) => {
    if (itemClicked === slug) {
      setOpenItem(!openItem);
      navigate(`/articles/${slug}`);
      action();
    } else {
      setOpenItem(true);
    }
    setItemClicked(slug);
  };

  const handleOpenSubItem = (slug1: string, slug2: string) => {
    if (subItemClicked === slug2) {
      setOpenSubItem(!openSubItem);
      navigate(`/articles/${slug1}/${slug2}`);
      action();
    } else {
      setOpenSubItem(true);
    }
    setSubItemClicked(slug2);
  };

  const handleItem = (slug1: string, slug2: string, slug3?: string) => {
    if (slug3) {
      navigate(`/articles/${slug1}/${slug2}/${slug3}`);
    } else {
      navigate(`/articles/${slug1}/${slug2}`);
    }

    action();
  };

  return (
    <div className="Mobile-Menu">
      {is_fetch === false ? (
        <LoadingOutlined />
      ) : (
        article_category.map((item: any, k: Key | null | undefined) => (
          <div className="Mobile-Menu" key={item.slug}>
            <MobileMenuItem
              path={`/articles/${item.slug}`}
              style="Mobile-Menu-Link"
              action={() => handleOpenItem(item.slug)}
              item={item}
              key={item.slug}
            />
            {openItem && itemClicked === item.slug && (
              <div className="Mobile-Menu-Sub-Item">
                {item.subcategories.map(
                  (child: any, ck: Key | null | undefined) =>
                    child.subcategories ? (
                      <div className="Mobile-Menu-Sub-Item" key={child.slug}>
                        <MobileMenuItem
                          path={`/articles/${item.slug}/${child.slug}`}
                          style="Mobile-Menu-Link"
                          action={() =>
                            handleOpenSubItem(item.slug, child.slug)
                          }
                          item={child}
                          key={child.slug}
                        />

                        {openSubItem && subItemClicked === child.slug && (
                          <div className="Mobile-Menu-Sub-Sub-Item">
                            {child.subcategories.map(
                              (final: any, fk: Key | null | undefined) => (
                                <MobileMenuItem
                                  path={`/articles/${item.slug}/${child.slug}/${final.slug}`}
                                  style="Mobile-Menu-Link"
                                  action={() =>
                                    handleItem(
                                      item.slug,
                                      child.slug,
                                      final.slug
                                    )
                                  }
                                  item={final}
                                  key={final.slug}
                                />
                              )
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      <MobileMenuItem
                        path={`/articles/${item.slug}/${child.slug}`}
                        style="Mobile-Menu-Link"
                        action={() => handleItem(item.slug, child.slug)}
                        item={child}
                        key={child.slug}
                      />
                    )
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default MobileMenu;
